import React, { useEffect, useRef } from "react";
import { useAuth } from "@/AuthContext";

export default function AuthCallback() {
  const { loginGoogleSession } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    const finish = async () => {
      if (sessionId) {
        try { await loginGoogleSession(sessionId); } catch {}
      }
      window.location.replace("/");
    };
    finish();
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
      <div className="font-mono-hs text-[#BC5D2E] text-sm uppercase tracking-widest animate-pulse">// connexion...</div>
    </div>
  );
}
